import React from 'react';
import { CheckCircle, Printer } from 'lucide-react';

export const PagoSuccessModal = ({ 
  isOpen, 
  onClose, 
  onPrint, 
  cantidadPagos,
  totalPagado 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
        
        {/* Header con Icono de Éxito */}
        <div className="bg-green-50 p-6 flex flex-col items-center justify-center text-center border-b border-green-100">
          <div className="bg-green-100 p-3 rounded-full mb-4">
             <CheckCircle className="w-10 h-10 text-green-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900">¡Pago Exitoso!</h2>
          <p className="text-green-700 mt-1 font-medium">
            Se han registrado {cantidadPagos} pago{cantidadPagos !== 1 ? 's' : ''} correctamente
          </p>
        </div>

        {/* Contenido / Resumen */}
        <div className="p-6 space-y-4">
          <div className="bg-gray-50 rounded-xl p-4 border border-gray-100">
             <div className="flex justify-between items-center mb-2">
                <span className="text-gray-500 text-sm">Total Cobrado</span>
                <span className="text-gray-900 font-bold text-lg">${totalPagado || '0.00'}</span>
             </div>
             <p className="text-gray-400 text-xs text-center border-t border-gray-200 pt-2 mt-2">
                Los comprobantes han sido generados automáticamente.
             </p>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="p-6 pt-2 bg-white flex flex-col gap-3">
          <button
            onClick={onPrint}
            className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-semibold flex items-center justify-center gap-2 transition-colors shadow-lg shadow-blue-100"
          >
            <Printer className="w-5 h-5" />
            Imprimir Comprobante{cantidadPagos !== 1 ? 's' : ''}
          </button>
          
          <button
            onClick={onClose}
            className="w-full py-3 bg-white hover:bg-gray-50 text-gray-700 border border-gray-200 rounded-xl font-semibold flex items-center justify-center gap-2 transition-colors"
          >
            Aceptar y Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default PagoSuccessModal;
